import { Inject, Injectable, LOCALE_ID, NgModule } from '@angular/core';
import { TranslationWidth } from '@angular/common';
import { NbDateService } from '@nebular/theme';
import * as _rollupMoment from 'moment';
import _rollupMoment__default from 'moment';

/*
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// @ts-ignore
import * as ɵngcc0 from '@angular/core';
const moment = _rollupMoment__default || _rollupMoment;
class NbMomentDateService extends NbDateService {
    constructor(locale) {
        super();
        this.TIME_ONLY_FORMAT_KEY = 'LT';
        this.setLocale(locale);
    }
    setLocale(locale) {
        super.setLocale(locale);
        this.setMomentLocaleData(locale);
    }
    setHours(date, hour) {
        return this.clone(date).set({ hour });
    }
    setMinutes(date, minute) {
        return this.clone(date).set({ minute });
    }
    setSeconds(date, second) {
        return this.clone(date).set({ second });
    }
    setMilliseconds(date, milliseconds) {
        return this.clone(date).set({ milliseconds });
    }
    addDay(date, days) {
        return this.clone(date).add({ days });
    }
    addMonth(date, months) {
        return this.clone(date).add({ months });
    }
    addYear(date, years) {
        return this.clone(date).add({ years });
    }
    addMinutes(date, minute) {
        return this.clone(date).add({ minute });
    }
    addHours(date, hour) {
        return this.clone(date).add({ hour });
    }
    clone(date) {
        return date.clone().locale(this.locale);
    }
    valueOf(date) {
        return date.valueOf();
    }
    compareDates(date1, date2) {
        return this.getYear(date1) - this.getYear(date2) ||
            this.getMonth(date1) - this.getMonth(date2) ||
            this.getDate(date1) - this.getDate(date2);
    }
    createDate(year, month, date) {
        return moment([year, month, date]);
    }
    format(date, format) {
        if (date) {
            return date.format(format || this.localeData.defaultFormat);
        }
        return '';
    }
    getLocaleTimeFormat() {
        return moment.localeData().longDateFormat(this.TIME_ONLY_FORMAT_KEY);
    }
    getDate(date) {
        return this.clone(date).date();
    }
    getDayOfWeek(date) {
        return this.clone(date).day();
    }
    getDayOfWeekNames(style = TranslationWidth.Narrow) {
        return this.localeData.days[style];
    }
    getFirstDayOfWeek() {
        return this.localeData.firstDayOfWeek;
    }
    getMonth(date) {
        return date.month();
    }
    getHours(date) {
        return date.hour();
    }
    getMinutes(date) {
        return date.minute();
    }
    getSeconds(date) {
        return date.second();
    }
    getMilliseconds(date) {
        return date.milliseconds();
    }
    getMonthEnd(date) {
        return this.clone(date).endOf('month');
    }
    getMonthName(date, style = TranslationWidth.Abbreviated) {
        const month = this.getMonth(date);
        return this.getMonthNameByIndex(month, style);
    }
    getMonthNameByIndex(month, style = TranslationWidth.Abbreviated) {
        return this.localeData.months[style][month];
    }
    getMonthStart(date) {
        return this.clone(date).startOf('month');
    }
    getNumberOfDaysInMonth(date) {
        return this.clone(date).daysInMonth();
    }
    getYear(date) {
        return this.clone(date).year();
    }
    getYearEnd(date) {
        return this.clone(date).endOf('year');
    }
    getYearStart(date) {
        return this.clone(date).startOf('year');
    }
    isSameDay(date1, date2) {
        return this.isSameMonth(date1, date2) && this.getDate(date1) === this.getDate(date2);
    }
    isSameMonth(date1, date2) {
        return this.isSameYear(date1, date2) && this.getMonth(date1) === this.getMonth(date2);
    }
    isSameYear(date1, date2) {
        return this.getYear(date1) === this.getYear(date2);
    }
    isValidDateString(date, format) {
        return moment(date, format).isValid();
    }
    isValidTimeString(date, format) {
        return moment(date, format, true).isValid();
    }
    parse(date, format) {
        return moment(date, format);
    }
    today() {
        return moment();
    }
    getId() {
        return 'moment';
    }
    setMomentLocaleData(locale) {
        const momentLocaleData = moment.localeData(locale);
        this.localeData = {
            firstDayOfWeek: momentLocaleData.firstDayOfWeek(),
            defaultFormat: momentLocaleData.longDateFormat('L'),
            months: {
                [TranslationWidth.Abbreviated]: momentLocaleData.monthsShort(),
                [TranslationWidth.Wide]: momentLocaleData.months(),
            },
            days: {
                [TranslationWidth.Wide]: momentLocaleData.weekdays(),
                [TranslationWidth.Short]: momentLocaleData.weekdaysShort(),
                [TranslationWidth.Narrow]: momentLocaleData.weekdaysMin(),
            },
        };
    }
    getWeekNumber(date) {
        return date.week();
    }
    getDateFormat() {
        return 'YYYY-MM-DD';
    }
    getTwelveHoursFormat() {
        return 'hh:mm A';
    }
}
NbMomentDateService.ɵfac = function NbMomentDateService_Factory(t) { return new (t || NbMomentDateService)(ɵngcc0.ɵɵinject(LOCALE_ID)); };
NbMomentDateService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: NbMomentDateService, factory: NbMomentDateService.ɵfac });
NbMomentDateService.ctorParameters = () => [
    { type: String, decorators: [{ type: Inject, args: [LOCALE_ID,] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NbMomentDateService, [{
        type: Injectable
    }], function () { return [{ type: String, decorators: [{
                type: Inject,
                args: [LOCALE_ID]
            }] }]; }, null); })();

/*
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
class NbMomentDateModule {
}
NbMomentDateModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NbMomentDateModule });
NbMomentDateModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function NbMomentDateModule_Factory(t) { return new (t || NbMomentDateModule)(); }, providers: [{ provide: NbDateService, useClass: NbMomentDateService }] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NbMomentDateModule, [{
        type: NgModule,
        args: [{
                providers: [{ provide: NbDateService, useClass: NbMomentDateService }]
            }]
    }], null, null); })();

/*
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NbMomentDateService, NbMomentDateModule };

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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